import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificationMode } from '../../../types/notification-mode';
import { getNotificationIcon } from '../../../utils/notification.utils';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.css'
})
export class NotificationComponent {
  @Input() title?: string;
  @Input() description?: string;
  @Input() mode: NotificationMode = 'success';
  @Output() closeToast = new EventEmitter<void>();

  public closeNotification(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.closeToast.emit();
  }

  public getIcon(mode: NotificationMode): string {
    return getNotificationIcon(mode);
  }
}
